/// <amd-module name="Build/Common/Library/Legacy/Components/TfvcSourceSelector" />
import * as React from "react";

import * as Resources from "Build/Common/Library/Legacy/Resources";
import { ShelvesetPickerActionHub } from "Build/Common/Library/Legacy/Components/ShelvesetAction";
import { ShelvesetPickerDialog } from "Build/Common/Library/Legacy/Components/ShelvesetPickerDialog";

import { IVssPageContext } from "VSS/Platform/Context";

import { FormItem } from "VSSUI/FormItem";
import { TextField } from "VSSUI/TextField";
import { Button } from "VSSUI/Button";


export interface ITfvcSourceSelectorState {
    showShelvesetPickerDialog: boolean;
}

export interface ITfvcSourceSelectorProps {
    pageContext?: IVssPageContext;
    projectId?: string;
    label?: string;
    sourceVersion?: string;
    shelvesetName?: string;
    actionHub?: ShelvesetPickerActionHub;
    onVersionSelected?: (branch: string) => void;
    onShelvesetSelected?: (shelevset: string) => void;
}

export class TfvcSourceSelector extends React.Component<ITfvcSourceSelectorProps, ITfvcSourceSelectorState> {
    private _showShelvesetPickerDialog: boolean = false;
    private _actionHub: ShelvesetPickerActionHub;

    constructor(props: ITfvcSourceSelectorProps) {
        super(props);
        
        this._actionHub = props.actionHub ? props.actionHub : new ShelvesetPickerActionHub();

        this.state = this._getState();
    }


    public render(): JSX.Element {
        return (
            <div className="tfvc-source-selector">
                <div>
                    <FormItem label={Resources.SourceVersionTextboxTitle}>
                        <TextField 
                            value={this.props.sourceVersion}
                            onChange={(e, newValue) => { 
                                if (this.props.onVersionSelected) {
                                    this.props.onVersionSelected(newValue)
                                }
                            }}
                        />
                    </FormItem>
                </div>
                {this.props.actionHub &&
                    <div className="shelveset-selector-container">
                        <div className="shelveset-name">
                            <FormItem label={Resources.ShelvesetTextboxTitle}>
                                <TextField 
                                    value={this.props.shelvesetName}
                                    onChange={(e, newValue) => { 
                                        if (this.props.onShelvesetSelected) {
                                            this.props.onShelvesetSelected(newValue)}
                                        }  
                                    }
                                /> 
                            </FormItem>
                        </div>
                        <div className="shelveset-picker-button">
                            <Button iconProps={{ iconName: "More" }} onClick={this._findShelveset} ariaLabel={Resources.MoreOptions} tooltipProps={{ text: Resources.OpenShelvesetPickerTooltip }} />
                        </div>
                        {this.state.showShelvesetPickerDialog && 
                            <ShelvesetPickerDialog 
                                pageContext={this.props.pageContext} 
                                project={this.props.projectId} 
                                actionHub={this._actionHub}
                            />
                        }
                    </div>
                }
            </div>
        );
    }

    private _findShelveset = () => {
        this._showShelvesetPickerDialog = true;
        this.setState(this._getState());
    }

    public componentDidMount() {
        this._actionHub.pickerDismissed.addListener(this._closeShelvesetPickerDialog);
    } 
        

    public componentWillUnmount() {
        this._actionHub.pickerDismissed.removeListener(this._closeShelvesetPickerDialog);
    }

    private _closeShelvesetPickerDialog = (shelvesetName: string) => {
        this._showShelvesetPickerDialog = false;
        this.setState(this._getState());
    }

    private _getState(): ITfvcSourceSelectorState {        
        return {
           showShelvesetPickerDialog: this._showShelvesetPickerDialog
        };
    }
}
